exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-panel {\n  font-size: 16px;\n  padding-top: 10px;\n  padding-bottom: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/claim/claim-export/claim-export.component.scss
// module id = ../../../../../src/app/claim/claim-export/claim-export.component.scss
// module chunks = main